import {ReactNode, useState} from "react";
import CreateFolderDialogContext from "./CreateFolderDialogContext";

type Props = {
    /**
     * Children to be wrapped
     * @since 0.1.9
     * @author Kacper Faber
     */
    children: ReactNode | ReactNode[];
};

/**
 * Wrap the CreateFolderDialogContext
 * @context CreateFolderDialogContext
 * @since 0.1.9
 * @author Kacper Faber
 */
function WrapCreateFolderDialogContext(props: Props) {
    /**
     * Is CreateFolderDialog opened.
     * @author Kacper Faber
     * @since 0.1.9
    */
    const [isOpened, setOpened] = useState(false);

    return (
        <CreateFolderDialogContext.Provider
            value={{ isOpened, setOpened }}
            children={props.children}
        />
    );
}

export default WrapCreateFolderDialogContext;